<template>
	<div class="py-3 bg-white" @load="loaded">
		<div class="flex navbar-breadcrumbs" v-if="!(classObj && students)">
			<span>
				<loading type="inline-header" />
			</span>
		</div>

		<template v-for="(student, i) in students">
			<div
				v-for="(result, j) in student.results"
				:key="`${i}-${j}`"
				class="d-flex flex-column card box mx-3 mb-3"
				style="page-break-after: always"
			>
				<div class="d-flex flex-row">
					<div class="flex" style="margin-bottom: 20px">
						<media :response="result.response" @setup="responseSetup(result)"></media>
					</div>
					<div class="side-panel px-2">
						<div class="card box mb-2">
							<h4 class="px-3 py-2 mb-0">{{ student.full_name }}</h4>
						</div>
						<div class="card box mb-3">
							<h4 class="px-3 pt-3">{{ result.assessment_name }}</h4>
							<div class="px-3 pb-3 text-muted text-md">{{ getDeliveryName(result) }}</div>
						</div>
						<div class="card box mb-3">
							<multi-score
								:scores="result.response.scores"
								:rubric="result.rubric"
								class="mb-3"
							></multi-score>
						</div>
						<template v-for="score in result.response.scores">
							<div
								class="px-4 py-2 card box w-100 mb-3 feedback-box"
								:key="score.id"
								v-if="score.student_feedback"
							>
								<i
									v-if="scoreTypeIconClass(score.score_type)"
									class="fas fa-lg"
									:class="scoreTypeIconClass(score.score_type)"
									v-tippy
									:title="scoreTypeTooltip(score, score.score_type)"
								></i>
								<i
									v-if="!scoreTypeIconClass(score.score_type)"
									class="material-icons"
									style="font-size: 28px; line-height: 30px"
									v-tippy
									:title="scoreTypeTooltip(firstScore)"
								>
									{{ scoreTypeIcon(score.score_type) }}
								</i>
								<strong>Feedback:</strong>
								<div v-html="score.student_feedback"></div>
							</div>
						</template>
						<div class="px-4 pb-2 text-center card box w-100 mb-2" v-if="result.response.weightedScore">
							<div class="text-xl">{{ fs.fixed012d(result.response.weightedScore) }}</div>
							<div class="text-muted">Final</div>
						</div>
						<div class="px-4 py-2 text-center card box w-100 mb-2" v-if="!result.response.weightedScore">
							<div class="text-muted">Scoring Not Complete</div>
						</div>
					</div>
				</div>
			</div>
		</template>

		<div v-if="classObj && students && students.length == 0" class="text-center">
			<h1 class="text-extra-muted mt-5">No student work</h1>
		</div>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.side-panel {
	width: 460px;
	margin-top: 20px;
}
.text-xl {
	font-size: 2rem;
}
body {
	background-color: white;
}
</style>

<script>
import ClassService from "@/services/ClassService";
import StudentService from "@/services/StudentService";
import AssessmentService from "@/services/AssessmentService";
import Media from "@/components/viewer/Media";
import MultiScore from "@/components/MultiScore";
import Notie from "@/services/NotieService";
import draggable from "vuedraggable";
import fs from "@/services/FormatService";
import store from "@/services/Store";
import BB from "bluebird";
import $ from "jquery";

export default {
	name: "StudentResults",

	props: ["user"],

	data() {
		return {
			fs: fs,
			assessment: null,
			item: null,
			deliveryID: null,
			classID: null,
			studentID: null,
			rubric: null,
			classObj: null,
			students: null,

			workStats: null,
		};
	},
	components: { draggable, Media, MultiScore },
	watch: {},
	computed: {},
	created() {
		this.deliveryID = this.$route.query.d;
		this.classID = this.$route.params.classID;
		this.studentID = this.$route.params.studentID;
		if (this.studentID) {
			this.loadDataSingle(this.classID, this.studentID);
		} else {
			this.loadDataMultiple(this.classID);
		}
	},
	methods: {
		loadDataSingle(classID, studentID) {
			return BB.props({
				class: ClassService.getClassAndAssessments(classID),
				student: StudentService.getStudent(studentID),
				results: ClassService.getStudentResults(classID, studentID),
			})
				.then((resps) => {
					this.classObj = resps.class.data.class;
					let student = resps.student.data;
					student.results = _.filter(resps.results.data.results, (result) => {
						return result.response.scores.length > 0;
					});
					_.each(student.results, (result) => {
						result.response.weightedScore = this.getFinalScore(result);
					});

					this.students = [student];
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to load student work", err);
				});
		},

		loadDataMultiple(classID) {
			return ClassService.getClassAndAssessments(classID)
				.then((resp) => {
					this.classObj = resp.data.class;
					let students = [];

					BB.map(this.classObj.student_ids, (studentID) => {
						return BB.props({
							student: StudentService.getStudent(studentID),
							results: ClassService.getStudentResults(classID, studentID),
						}).then((resps) => {
							let student = resps.student.data;
							student.results = _.filter(resps.results.data.results, (result) => {
								return result.response.scores.length > 0;
							});
							_.each(student.results, (result) => {
								result.response.weightedScore = this.getFinalScore(result);
							});

							if (student.results.length > 0) {
								students.push(student);
							}
						});
					})
						.then(() => {
							this.students = students;
						})
						.catch((err) => {
							console.log(err);
							Notie.error("Failed to load student work", err);
						});
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to load student work", err);
				});
		},

		progressIcon(delta) {
			if (delta < 0) {
				return "fa-chevron-down";
			} else if (delta > 0) {
				return "fa-chevron-up";
			} else {
				return "";
			}
		},

		progressClass(delta) {
			if (delta == undefined) {
				return "";
			}

			if (delta < 0) {
				return "text-danger";
			} else if (delta > 0) {
				return "text-success";
			} else {
				return "text-warning";
			}
		},

		scoreTypeIcon(scoreType) {
			return fs.scoreTypeIcon(scoreType);
		},
		scoreTypeIconClass(scoreType) {
			return fs.scoreTypeIconClass(scoreType);
		},
		scoreTypeStr(scoreType) {
			let ret = fs.scoreTypeName(scoreType);
			if (this.hasUser) {
				return `${ret}:`;
			} else {
				return ret;
			}
		},
		scoreTypeTooltip(score, scoreType) {
			let tooltip = `<strong>${this.scoreTypeStr(scoreType)} Score</strong>`;
			if (score) {
				tooltip += `<br /><span class="text-muted"><i class="fal fa-clock"></i> ${fs.fullDate(
					score.created_at
				)}</span>`;
			} else {
				tooltip += `<br /><span class="text-muted">Not yet applied</span>`;
			}

			return tooltip;
		},
		getTraitName(traitID) {
			let trait = _.find(this.rubric.traits, { id: traitID });
			if (trait) {
				return trait.name;
			} else {
				return "?";
			}
		},

		openScore(response) {
			if (!response.media || response.media.length == 0) {
				return;
			}

			let aid = response.assessment_id;
			let iid = response.item_id;
			let cid = response.class_id;
			let did = response.delivery_id;
			let rid = response.id;
			ViewingDriver.enter(this, aid, iid, rid);
		},

		getDeliveryName(result) {
			let delivery = _.find(this.classObj.deliveries, {
				id: result.response.delivery_id,
			});
			console.log(delivery);
			return delivery.name;
		},

		getFinalScore(result) {
			if (result.response.state != 10) {
				return null;
			}

			let res_score = _.find(result.response.scores, { score_type: 3 });
			if (res_score) {
				return this.getWeightedScore(res_score, result.rubric);
			}

			let first_score = _.find(result.response.scores, {
				score_type: 1,
			});
			let second_score = _.find(result.response.scores, {
				score_type: 2,
			});
			if (first_score && second_score) {
				return this.getWeightedScoreAverage(first_score, second_score, result.rubric);
			}

			if (first_score) {
				return this.getWeightedScore(first_score, result.rubric);
			}

			return null;
		},

		getWeightedScore(score, rubric) {
			let unweighted = _.every(rubric.traits, {
				weight: 0,
			});

			let weighted_score = 0;
			_.each(score.trait_scores, (ts) => {
				if (unweighted) {
					weighted_score += ts.score;
				} else {
					let trait = _.find(rubric.traits, {
						id: ts.trait_id,
					});
					weighted_score += ts.score * trait.weight;
				}
			});

			return weighted_score;
		},

		getWeightedScoreAverage(scoreObj1, scoreObj2, rubric) {
			let unweighted = _.every(rubric.traits, {
				weight: 0,
			});

			let weighted_score = 0;
			_.each(scoreObj1.trait_scores, (score1) => {
				const score2 = _.find(scoreObj2.trait_scores, { trait_id: score1.trait_id });
				if (!score2) {
					console.log("Scores did not match", scoreObj1, scoreObj2);
					return;
				}
				if (unweighted) {
					weighted_score += (score1.score + score2.score) / 2;
				} else {
					let trait = _.find(rubric.traits, {
						id: score1.trait_id,
					});
					weighted_score += ((score1.score + score2.score) / 2) * trait.weight;
				}
			});
			return weighted_score;
		},

		responseSetup(result) {
			result.setupFinished = true;

			if (this.allSetup()) {
				setTimeout(() => {
					window.print();
				}, 1000);
			}
		},

		allSetup() {
			let all = true;
			_.each(this.students, (student) => {
				_.each(student.results, (result) => {
					if (!result.setupFinished) {
						all = false;
					}
				});
			});

			return all;
		},

		loaded() {
			//console.log("ALL CONTENT LOADED");
		},
	},
};
</script>





// WEBPACK FOOTER //
// src/vues/Classes/StudentResultsPrint.vue